import { z } from 'zod'

export const setupSearchSchema = z.object({
  setup: z.enum(['whatsapp', 'ai']).optional().catch(undefined),
})
export type SetupMode = NonNullable<z.infer<typeof setupSearchSchema>['setup']>
export type SetupStep = 1 | 2 | 3

export function nextSetupStep(step: SetupStep): SetupStep {
  return step === 1 ? 2 : 3
}

export function previousSetupStep(step: SetupStep): SetupStep {
  return step === 3 ? 2 : 1
}
